module.exports = __webpack_public_path__ + "static/media/Practicas_agiles_con_Jira.0c248021.png";